import React, { PureComponent } from "react";
import { Form, message, Modal, Select, DatePicker, Checkbox } from "antd";
import { withTranslation, Trans } from "react-i18next";
import { postUpdateLog } from '../../../axios';
import { regionsOptions } from '../Const'
import QuillEditor from '../EditorComponent/quill'

import moment from 'moment';
import { add } from "lodash";
const { Option } = Select;
@withTranslation(["common"])
class EditorComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            editorContent: '',
            editorContent1: '',
            dateValue: moment(),
            lang: 'en-US',
            dateString: moment().format("YYYY-MM-DD"),
            check: ['eu', 'us', 'cn', 'ca', 'jp', 'au'],
            addLoading: false
            // , 'au'
        };
    }

    componentDidMount() {
        const { editData } = this.props;
        if (editData) {
            this.setState({
                editorContent: editData.issues,
                editorContent1: editData.features,
                dateValue: moment(editData.log_date),
                dateString: moment(editData.log_date).format("YYYY-MM-DD"),
                lang: editData.al,
                check: editData.region || ['eu', 'us', 'cn', 'ca', 'jp', 'au']
            });
        }
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
    }

    handleCancel = (e) => {
        this.props.close();
    };


    handleOk = () => {
        const { editorContent, editorContent1, dateString, lang, check } = this.state;
        let data = {
            "logDate": dateString,
            "features": editorContent1,
            "issues": editorContent,
            "al": lang,
            "region": check
        }
        postUpdateLog(data).then(res => {
            if (res.code === 100000) {
                message.success(this.props.t('PublishedTips'))
                this.setState({ addLoading: false });
                this.props.close(1)
            } else {
                if (res.data.failedRegions) {
                    const failedRegions = res.data.failedRegions.map(item => {
                        const findItem = regionsOptions.find(option => option.value === item)
                        return findItem ? findItem.label : item
                    })
                    const msg = (
                        <Trans i18nKey="FailedTips" values={{ region: failedRegions.join(',') }} t={this.props.t} />
                    )
                    message.error(res.data.failedRegions && res.data.failedRegions.length > 0 ? msg : res.msg)
                } else {
                    message.error(res.data)
                }
                this.setState({ addLoading: false });
                this.props.close(1)
            }
        })
    };

    dateOnChange = (date, dateString) => {
        console.log(date, dateString);
        this.setState({
            dateValue: date,
            dateString: dateString
        })
    }

    handleChange = (e) => {
        this.setState({
            lang: e
        })
    }

    onChange = (checkedValues) => {
        this.setState({
            check: checkedValues
        })
    }

    onChangeContent = (content) => {
        this.setState({
            editorContent: content
        })
    }
    onChangeContent1 = (content) => {
        this.setState({
            editorContent1: content
        })
    }

    render() {
        const t = this.props.t;
        const { visible } = this.props;
        const {
            editorContent,
            editorContent1,
            dateValue,
            lang,
            check
        } = this.state;

        // Common form item layout
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 }
        };

        return (
            <Modal
                title={t("Add Log")}
                visible={visible}
                onCancel={() => {
                    this.props.close();
                }}
                onOk={() => {
                    this.setState({ addLoading: true });
                    this.handleOk()
                }}
                width={660}
                confirmLoading={this.state.addLoading}
                className="editor-modal"
                centered={true}
                maskClosable={false}
            >
                <Form>
                    <Form.Item
                        {...formItemLayout}
                        label={t("Date")}
                        name="Date"
                    >
                        <DatePicker
                            format="YYYY-MM-DD"
                            value={dateValue}
                            allowClear={false}
                            autoFocus={true}
                            onChange={(date, dateString) => { this.dateOnChange(date, dateString) }}
                        />
                    </Form.Item>
                    <Form.Item
                        {...formItemLayout}
                        label={t("Language")}
                        name="Date"
                    >
                        <Select value={lang} style={{ width: 120 }} onChange={(e) => this.handleChange(e)}>
                            <Option value="en-US">English</Option>
                            <Option value="zh-CN">Chinese</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        {...formItemLayout}
                        label={t("New features")}
                        name="features"
                        className="weditor"
                    >
                        <div style={{ width: "460px" }} >
                            <QuillEditor content={editorContent1} onRef={node => this.Editor = node} onChange={this.onChangeContent1}></QuillEditor>
                        </div>
                    </Form.Item>
                    <Form.Item
                        {...formItemLayout}
                        label={t("Resolved issues")}
                        name="issues"
                        className="weditor"
                    >
                        <div style={{ width: "460px" }} >
                            <QuillEditor content={editorContent} onRef={node => this.Editor = node} onChange={this.onChangeContent}></QuillEditor>
                        </div>
                    </Form.Item>
                    <Form.Item
                        {...formItemLayout}
                        label={t("region")}
                        name="region"
                    >
                        <Checkbox.Group options={regionsOptions} defaultValue={check} onChange={this.onChange} />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

export default EditorComponent;
